<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <title v-if="title">{{ title }}</title>
    <path
      d="M15.318 1v4.123C9.844 5.46 5.455 9.846 5.112 15.318H1v1.364h4.112c.338 5.477 4.729 9.868 10.206 10.206V31h1.364v-4.112c5.477-.338 9.868-4.729 10.206-10.206H31v-1.364h-4.112c-.343-5.472-4.732-9.858-10.206-10.195V1h-1.364zm0 5.487v4.058h1.364V6.487a9.524 9.524 0 0 1 8.831 8.831h-4.058v1.364h4.058a9.523 9.523 0 0 1-8.831 8.842v-4.07h-1.364v4.07a9.525 9.525 0 0 1-8.832-8.842h4.06v-1.364h-4.06a9.525 9.525 0 0 1 8.832-8.831z"
      fill="currentColor"
      fill-rule="nonzero"
      stroke="currentColor"
      stroke-width=".4"
    />
  </svg>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: undefined,
  },
});
</script>
